var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 19.375C1.25 19.2092 1.31585 19.0503 1.43306 18.9331C1.55027 18.8158 1.70924 18.75 1.875 18.75H18.125C18.2908 18.75 18.4497 18.8158 18.5669 18.9331C18.6842 19.0503 18.75 19.2092 18.75 19.375C18.75 19.5408 18.6842 19.6997 18.5669 19.8169C18.4497 19.9342 18.2908 20 18.125 20H1.875C1.70924 20 1.55027 19.9342 1.43306 19.8169C1.31585 19.6997 1.25 19.5408 1.25 19.375ZM14.375 2.5H13.75V1.25H14.375C14.8723 1.25 15.3492 1.44754 15.7008 1.79917C16.0525 2.15081 16.25 2.62772 16.25 3.125V18.75H15V3.125C15 2.95924 14.9342 2.80027 14.8169 2.68306C14.6997 2.56585 14.5408 2.5 14.375 2.5Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.535 0.152528C13.6026 0.211282 13.6568 0.283879 13.6939 0.3654C13.731 0.446922 13.7501 0.535463 13.75 0.625028V18.75H12.5V1.34628L5 2.41753V18.75H3.75V1.87503C3.75002 1.72444 3.80441 1.57893 3.90317 1.46525C4.00192 1.35157 4.1384 1.27736 4.2875 1.25628L13.0375 0.00627768C13.1261 -0.00636989 13.2163 0.000141799 13.3021 0.0253726C13.388 0.0506034 13.4674 0.0939654 13.535 0.152528Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25C10 11.94 10.28 12.5 10.625 12.5C10.97 12.5 11.25 11.94 11.25 11.25C11.25 10.56 10.97 10 10.625 10C10.28 10 10 10.56 10 11.25Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpen);
export default __webpack_public_path__ + "static/media/doorOpen.36207fca.svg";
export { ForwardRef as ReactComponent };